module.exports = __webpack_public_path__ + "static/media/video.eabef435.svg";